import React, { useEffect, useState } from 'react';
import { saveStateSession } from '../../../Components/FlyfishComponents/flyfishutils/utils';

const useScreenType = () => {
	const [screenSize, setScreenSize] = useState(getScreenSize());

	useEffect(() => {
		const handleResize = () => {
			const newSize = getScreenSize();
			if (newSize !== screenSize) {
				setScreenSize(newSize);
				saveStateSession('deviceType', newSize);
			}
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [screenSize]);

	return screenSize;
};

export const getScreenSize = () => {
	const width = window.innerWidth;
	if (width >= 1200) return 'desktop';
	if (width >= 600) return 'tablet';
	return 'mobile';
};

export default useScreenType;
